import Visibility from '@mui/icons-material/Visibility';
import { Button, Typography } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { useSignatureContext } from '../contexts/signature.context';
import { SignedContract } from '../signed-contract';
import { ModalContractPage } from '../types';

type AvailableActionsProps = {
  signed: SignedContract;
};

const ContractHistoryActions = ({ signed }: AvailableActionsProps) => {
  const { translate } = useTranslation();
  const { changePage } = useSignatureContext();

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<Visibility />}
      onClick={() => {
        changePage(ModalContractPage.READ_CONTRACT_ONLY, signed);
      }}
    >
      <Typography>{translate(LangEnum.ORDER_CONTRACT_HISTORY_TABLE_CELL_VISUALIZE)}</Typography>
    </Button>
  );
};
export default ContractHistoryActions;
